

<template>
    <section class="relative z-0 bg-cover bg-center text-white text-center pt-40 pb-20 px-4">
     
    </section>
  </template>
  